export default __webpack_public_path__ + "static/hero-mobile-8fb461e3440e47a919210de8aa1466d7.jpg";